import cafePanorama from './cafe_panorama.jpg'
import cafeTerrasa from './cafe_terrasa.jpg'
import cityPark1 from './city_park_1.jpg'
import cafe2 from './cafe_2.jpg'
//  import cityPark2 from './city_park_2.jpg'

export { cafeTerrasa, cafePanorama, cityPark1, cafe2 }



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/components/RestaurantAndCafe/images/index.js